import { useInfiniteQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { useCallback } from 'react';

import { fetchMerchantVenuesV3 } from 'apis/restaurant-api/merchant-admin/venue/api';
import { MerchantVenuesResponseV3 } from 'apis/restaurant-api/merchant-admin/venue/types';

const useMerchantVenues = (isEnabled: boolean, merchantId: string, pageSize: number) => {
  const { data, error, isLoading, fetchNextPage, hasNextPage, isFetchingNextPage } = useInfiniteQuery<
    MerchantVenuesResponseV3,
    AxiosError
  >({
    queryFn: useCallback(
      ({ pageParam: pageToken = '' }) => fetchMerchantVenuesV3(merchantId, pageSize, pageToken),
      [merchantId, pageSize],
    ),
    queryKey: ['/v3/merchant-admin/merchant-venues/', merchantId],
    getNextPageParam: (lastPage: MerchantVenuesResponseV3) => lastPage.next_page_token,
    enabled: isEnabled && !!merchantId,
    refetchOnWindowFocus: false,
  });

  return { data, error, isLoading, fetchNextPage, hasNextPage, isFetchingNextPage };
};

export default useMerchantVenues;
